import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-itinerary-boat',
  templateUrl: './itinerary-boat.component.html',
  styleUrls: ['./itinerary-boat.component.css']
})
export class ItineraryBoatComponent {
 @Input() boatId: number | null = null ;// To receive boat ID from the parent component
 @Input() boatSlug: string | undefined; // Tambahkan input untuk slug
 @Input() boatItinerary: any | []; 
  
  isAccordionOpen: boolean[] = [];

  toggleAccordion(index: number): void {
    // Membalikkan status panel tertentu
    this.isAccordionOpen[index] = !this.isAccordionOpen[index];
  } 
}
